export default __webpack_public_path__ + "static/media/grade-blue.fc9ba9d3.svg";